import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CompanyProvider } from './context/CompanyContext';
import { Toaster } from './components/ui/sonner';
import LoginPage from './pages/LoginPage';
import RecoverPage from './pages/RecoverPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import FilesPage from './pages/FilesPage';
import ExpensesPage from './pages/ExpensesPage';
import DatasheetsPage from './pages/DatasheetsPage';
import DatasheetDetailPage from './pages/DatasheetDetailPage';
import PasswordsPage from './pages/PasswordsPage';
import EmployeesPage from './pages/EmployeesPage';
import ShareholdersPage from './pages/ShareholdersPage';
import VestingPage from './pages/VestingPage';
import VamStatsPage from './pages/VamStatsPage';
import NoteholdersPage from './pages/NoteholdersPage';
import ReportsPage from './pages/ReportsPage';
import RevenuePage from './pages/RevenuePage';
import SharedReportPage from './pages/SharedReportPage';
import PersonalDashboardPage from './pages/PersonalDashboardPage';
import PersonalHomePage from './pages/PersonalHomePage';
import VehiclesPage from './pages/VehiclesPage';
import PreciousMetalsPage from './pages/PreciousMetalsPage';
import FinancialAccountsPage from './pages/FinancialAccountsPage';
import LiabilitiesPage from './pages/LiabilitiesPage';
import SpendingPage from './pages/SpendingPage';
import SettingsPage from './pages/SettingsPage';
import CabexClientsPage from './pages/CabexClientsPage';
import CabexReportsPage from './pages/CabexReportsPage';
import HomePage from './pages/HomePage';
import UsersPage from './pages/UsersPage';
import PraxisDashboardPage from './pages/PraxisDashboardPage';
import PraxisClientsPage from './pages/PraxisClientsPage';
import PraxisClientDetailPage from './pages/PraxisClientDetailPage';
import DashboardLayout from './components/layout/DashboardLayout';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/login/recover" element={<RecoverPage />} />
            <Route path="/shared-report/:token" element={<SharedReportPage />} />
            
            <Route element={<DashboardLayout />}>
              {/* Home / workspaces selector */}
              <Route path="/home" element={<HomePage />} />

              {/* Business routes */}
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/clients/:clientId" element={<ClientDetailPage />} />
              <Route path="/files" element={<FilesPage />} />
              <Route path="/expenses" element={<ExpensesPage />} />
              <Route path="/revenue" element={<RevenuePage />} />
              <Route path="/passwords" element={<PasswordsPage />} />
              <Route path="/datasheets" element={<DatasheetsPage />} />
              <Route path="/datasheets/:datasheetId" element={<DatasheetDetailPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/settings/users" element={<UsersPage />} />
              <Route path="/employees" element={<EmployeesPage />} />
              <Route path="/shareholders" element={<ShareholdersPage />} />
              <Route path="/vesting" element={<VestingPage />} />
              <Route path="/vam-stats" element={<VamStatsPage />} />
              <Route path="/noteholders" element={<NoteholdersPage />} />

              {/* Cabex routes */}
              <Route path="/cabex/clients" element={<CabexClientsPage />} />
              <Route path="/cabex/reports" element={<CabexReportsPage />} />

              {/* Praxis Sigma routes */}
              <Route path="/praxis/dashboard" element={<PraxisDashboardPage />} />
              <Route path="/praxis/clients" element={<PraxisClientsPage />} />
              <Route path="/praxis/clients/:id" element={<PraxisClientDetailPage />} />

              {/* Personal dashboard routes */}
              <Route path="/personal" element={<PersonalHomePage />} />
              <Route path="/personal/assets" element={<PersonalDashboardPage />} />
              <Route path="/personal/assets/vehicles" element={<VehiclesPage />} />
              <Route path="/personal/assets/metals" element={<PreciousMetalsPage />} />
              <Route path="/personal/assets/financial" element={<FinancialAccountsPage />} />
              <Route path="/personal/assets/:typeSlug" element={<PersonalDashboardPage />} />
              <Route path="/personal/liabilities" element={<LiabilitiesPage />} />
              <Route path="/personal/liabilities/:typeSlug" element={<LiabilitiesPage />} />
              <Route path="/personal/spending" element={<SpendingPage />} />
              <Route path="/personal/contacts" element={<ClientsPage />} />
              <Route path="/personal/passwords" element={<PasswordsPage />} />
              <Route path="/personal/files" element={<FilesPage />} />
            </Route>
            
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </CompanyProvider>
    </AuthProvider>
  );
}

export default App;
